import { atom } from 'recoil';

import { PlanUnitMix, Scenario } from 'components/types';

const composeAtomKey = (name: string) => `CapacityPlan_${name}`;

export const activeTabAtom = atom<number>({
  key: composeAtomKey('activeTab'),
  default: 0
});

export const formationTabAtom = atom<number>({
  key: composeAtomKey('formationTab'),
  default: -1
});

export const scenarioAtom = atom<Scenario | null>({
  key: composeAtomKey('scenario'),
  default: null
});

export const planUnitsAtom = atom<PlanUnitMix[]>({
  key: composeAtomKey('planUnits'),
  default: []
});

export const scenarioBarOpenAtom = atom<boolean>({
  key: composeAtomKey('scenarioBarOpen'),
  default: true
});
